<app-accordion
  [title]="title"
  titleClass="text-secondary text-lg font-semibold"
  [badgeIcon]="badgeIcon"
  badgeClass="chip chip-small chip-discarded"
  (openChange)="onAccordionOpenChange($event)">
  <!-- In the header only while the accordion is closed, which is when the textarea that would
       otherwise carry the highlight is not in the DOM at all. -->
  <app-presence-avatars accordionHeaderExtra [viewers]="headerViewers()" />
  <app-textarea
    #textarea
    [field]="field()"
    [id]="id()"
    label=""
    [rows]="rows()"
    [placeholder]="placeholder()"
    [containerClass]="containerClass()"
    [textareaClass]="textareaClass()" />
</app-accordion>
